import React from "react";

interface ButtonProps {
  type?: "button" | "submit" | "reset";
  disabled?: boolean;
  isLoading?: boolean;
  loadingText?: string;
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  variant?: "primary" | "secondary" | "outline" | "ghost";
  size?: "sm" | "md" | "lg";
}

const Button: React.FC<ButtonProps> = ({
  type = "button",
  disabled = false,
  isLoading = false,
  loadingText = "Đang xử lý...",
  children,
  onClick,
  className = "",
  variant = "primary",
  size = "md",
}) => {
  const baseClasses =
    "focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed transition-colors font-medium";

  const sizeClasses = {
    sm: "py-1.5 px-3 text-xs",
    md: "py-2 px-4 text-sm",
    lg: "py-3 px-6 text-base",
  };

  const variantClasses = {
    primary:
      "bg-[#0087C1] text-white hover:bg-[#0070a3] focus:ring-[#0087C1] rounded-md",
    secondary:
      "bg-gray-200 text-gray-800 hover:bg-gray-300 focus:ring-gray-500 rounded-md",
    outline:
      "border border-[#0087C1] text-[#0087C1] hover:bg-[#0087C1] hover:text-white focus:ring-[#0087C1] rounded-md",
    ghost: "text-[#0087C1] focus:ring-[#0087C1] rounded-md",
  };

  const widthClass = variant === "ghost" ? "" : "w-full";

  return (
    <button
      type={type}
      disabled={disabled || isLoading}
      onClick={onClick}
      className={`${baseClasses} ${sizeClasses[size]} ${variantClasses[variant]} ${widthClass} ${className}`}
    >
      {isLoading ? (
        <div className="flex items-center justify-center">
          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-current mr-2"></div>
          {loadingText}
        </div>
      ) : (
        children
      )}
    </button>
  );
};

export default Button;
